import React, { useState, useImperativeHandle, forwardRef } from 'react';


import './Carousel.css';
import MealCard from '../MealCard/MealCard';

const Carousel = forwardRef(({ items, nitemsToShow }, ref) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const itemsToShow = nitemsToShow != null ? nitemsToShow : 5;
    const totalItems = items.length;

    const handleNext = () => {
        if ((currentIndex + itemsToShow) < totalItems) {
            setCurrentIndex((prevIndex) => (prevIndex + itemsToShow) % totalItems);
        }
    };

    const handlePrev = () => {
        if ((currentIndex - itemsToShow) >= 0) {
            setCurrentIndex(
                (prevIndex) => (prevIndex - itemsToShow + totalItems) % totalItems
            );
        }
    };

    // Expose methods to parent component
    useImperativeHandle(ref, () => ({
        getCurrentIndex: () => currentIndex,
        next: handleNext,
        prev: handlePrev,
    }));

    // 
    return (
        < div className="carousel" >
            <div className={"carousel-items justify_space_around"}>
                {items.slice(currentIndex, currentIndex + itemsToShow).map((item, index) => (
                    <MealCard item={item} index={index} key={index} />
                ))}
            </div>
        </div >
    );
});

export default Carousel;
